import { Table } from "react-bootstrap";
import { addCommas } from "@persian-tools/persian-tools";
export default function FactorTable({ factorList, fabricList }) {
  return (
    <Table striped bordered={true} responsive>
      <thead>
        <tr>
          <th style={{ width: 70 }}>#</th>
          <th style={{ width: 300 }}>شرح کالا</th>
          <th style={{ width: 100 }}>تعداد</th>
          <th style={{ width: 200 }}>
            قیمت واحد <span style={{ fontSize: 10 }}>(تومان)</span>
          </th>
          <th style={{ width: 200 }}>
            تخفیف <span style={{ fontSize: 10 }}>(تومان)</span>
          </th>
          <th style={{ width: 200 }}>
            قیمت کل <span style={{ fontSize: 10 }}>(تومان)</span>
          </th>
        </tr>
      </thead>
      <tbody>
        {factorList?.map((value, index) => {
          let pieces = 1;
          let f1 =
            fabricList.filter(
              (v) => v.id == value?.apfo_info[0]?.p1_fabric_id
            )[0].title ?? "";
          let f2 =
            fabricList.filter(
              (v) => v.id == value?.apfo_info[0]?.p2_fabric_id
            )[0].title ?? "";
          let f3 =
            fabricList.filter(
              (v) => v.id == value?.apfo_info[0]?.p3_fabric_id
            )[0].title ?? "";
          let finaltxt = false;
          if (
            (value?.apfo_info[0]?.p1_fabric_id != 0 ? 1 : 0) +
              (value?.apfo_info[0]?.p2_fabric_id != 0 ? 1 : 0) +
              (value?.apfo_info[0]?.p3_fabric_id != 0 ? 1 : 0) ==
            2
          ) {
            pieces = "دو";
          } else if (
            (value?.apfo_info[0]?.p1_fabric_id != 0 ? 1 : 0) +
              (value?.apfo_info[0]?.p2_fabric_id != 0 ? 1 : 0) +
              (value?.apfo_info[0]?.p3_fabric_id != 0 ? 1 : 0) ==
            3
          ) {
            pieces = "سه";
          }
          if (
            value?.apfo_info[0]?.p1_fabric_id != 0 &&
            value?.apfo_info[0]?.p1_fabric_id != undefined
          ) {
            finaltxt = `تکه اول: ${f1} - ${value?.apfo_info[0]?.p1_height} سانتی متر`;
            if (
              value?.apfo_info[0]?.p2_fabric_id != 0 &&
              value?.apfo_info[0]?.p2_fabric_id != undefined
            ) {
              finaltxt += `/ تکه دوم: ${f2} - ${value?.apfo_info[0]?.p2_height} سانتی متر`;
              if (
                value?.apfo_info[0]?.p3_fabric_id != 0 &&
                value?.apfo_info[0]?.p3_fabric_id != undefined
              ) {
                finaltxt += `
                 / تکه سوم: ${f3} - ${value?.apfo_info[0]?.p3_height} سانتی متر`;
              }
            }
          }
          console.log(
            "debuga",
            fabricList.filter(
              (v) => v.id == value?.apfo_info[0]?.p2_fabric_id
            )[0].label
          );

          return (
            <>
              {value.product_structure_id != 4 && (
                <tr>
                  <td>{index + 1}</td>
                  <td style={{ lineHeight: 1.4 }}>
                    <span dir="rtl"> {value.title} </span> &nbsp;&nbsp;
                    {value.apfo_info.length > 0
                      ? `${value?.apfo_info[0]?.ps_width ?? ""} *
                    ${value?.apfo_info[0]?.ps_height ?? ""}`
                      : ""}
                    {pieces != 1 ? ` - ${pieces} تکه` : ""}
                    {value?.apfo_info[0]?.ps_gramaj
                      ? ` - ${value?.apfo_info[0]?.ps_gramaj} گرم`
                      : ""}
                    <br />
                    {finaltxt ?? ""}
                  </td>
                  <td>{value.count}</td>
                  <td>{addCommas(value.price)}</td>
                  <td>{addCommas(value.discount)}</td>
                  <td>
                    {addCommas(
                      parseInt(value.price) * parseInt(value.count) -
                        parseInt(value.discount)
                    )}
                  </td>
                </tr>
              )}
              {value.OptionOrderItem.map((val, ind) => {
                return (
                  <>
                    {val?.value[0]?.value?.priceOnOrder != 0 && (
                      <>
                        <tr>
                          <td>
                            {value.product_structure_id != 4
                              ? `${ind + 1}-${index + 1}`
                              : index + 1}
                          </td>
                          <td>
                            {val[0]?.title}({val?.value[0]?.value?.name}
                            {/* روی
                            سفارش */}
                            )
                          </td>
                          <td>{1}</td>
                          <td>
                            {addCommas(val?.value[0]?.value?.priceOnOrder)}
                          </td>
                          <td>{addCommas(0)}</td>
                          <td>
                            {addCommas(
                              parseInt(val?.value[0]?.value?.priceOnOrder)
                            )}
                          </td>
                        </tr>
                      </>
                    )}
                    {val?.value[0]?.value?.pricePerUnit != 0 && (
                      <>
                        <tr>
                          <td>
                            {value.product_structure_id != 4
                              ? `${ind + 1}-${index + 1}`
                              : index + 1}
                          </td>
                          <td>
                            {val[0]?.title}({val?.value[0]?.value?.name}
                            {/* هر
                            واحد */}
                            )
                          </td>
                          <td>{value.count}</td>
                          <td>
                            {addCommas(val?.value[0]?.value?.pricePerUnit)}
                          </td>
                          <td>{0}</td>
                          <td>
                            {addCommas(
                              parseInt(val?.value[0]?.value?.pricePerUnit) *
                                parseInt(value.count)
                            )}
                          </td>
                        </tr>
                      </>
                    )}
                  </>
                );
              })}
            </>
          );
        })}
      </tbody>
    </Table>
  );
}
